import React, { useState } from 'react';
import { Container, Accordion, Icon } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';
import Txt from '../../../inputs/textInput.js';
import TextAreaWithCharacterLimit from '../../../inputs/textAreaWithCharacterLimit.js';
import ReactQuill from 'react-quill';
import HtmlToReact from 'html-to-react';
let htmlToReactParser = new HtmlToReact.Parser(React);

const ReactQuillContent = React.memo(({ modules, message }) => {
  // Avoid unnecessary re-render when center panel state updates
  return (
    <ReactQuill
      readOnly={true}
      modules={ReactQuillModules}
      value={message}
      className="rich-text-editor"
      id="share-link-wa"
    />
  );
});

const MobileTextAreaContent = React.memo(({ message, onChange, characterLimit, errorMsg, backdropId, tabIndex }) => {
  // Avoid unnecessary re-render when center panel state updates
  return (
    <TextAreaWithCharacterLimit
      message={message}
      onChange={onChange}
      characterLimit={characterLimit}
      errorMsg={errorMsg}
      backdropId={backdropId}
      tabIndex={tabIndex}
    />
  );
});

const CenterPanel = (props) => {
  const [settingAccordion, setSettingAccordion] = useState(-1);

  // This function is to convert all next line symbol (/n/r) to <br > or "" depending on the format we like to display
  const translateToQuill = (str) => {
    let newStr = str.replace(/\r?\n?\t|\r?\n|\r/g, '\n').replace(/\n/g, '<br />');
    return newStr;
  };

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = settingAccordion === index ? -1 : index;
    setSettingAccordion(newIndex);
  };

  return (
    <div className="ui form mrbl pdtsss">
      <div className="title-sms text-size-ml bold mrtxs">{APP.LANGUAGE.ViewWaitingArea.ShareByText}</div>
      <div className="title-sms bold mrts mrbxs">{APP.LANGUAGE.ShareURL.Mobile}</div>
      <div className="mrbm">
        <Txt
          tabIndex="1"
          id="mobile"
          focusme="true"
          placeholder={APP.LANGUAGE.ShareURL.Mobile}
          noTitle
          value={props.formik.values.mobile}
          customOnBlur={true}
          customOnChange={true}
          notRenderPlaceholderAsTitle={true}
          onChange={props.formik.handleChange}
          onBlur={props.formik.handleBlur}
        >
          {props.formik.errors.mobile && (
            <React.Fragment>
              {props.showMobileErrorDetail ? (
                <div className="error-label">
                  <span className="error-pointy-corner" />
                  <span className="error-color">{props.formik.errors.mobile}</span>
                </div>
              ) : (
                ''
              )}
              <i
                className="warning big circle icon error-checkmark"
                onClick={() => {
                  props.setShowMobileErrorDetail(true);
                }}
              />
            </React.Fragment>
          )}
        </Txt>
      </div>
      <div className="mrtl mrbm">
        <div className="title-sms text-size-ml bold mrts mrbxs">{APP.LANGUAGE.ShareURL.TextMessage}</div>
        <Container fluid as={Media} at="tablet">
          <hr style={{ border: '1px solid #e6e6e6' }} />
        </Container>
        <Container as={Media} at="mobile" className="fluid round-corner mrbm">
          <hr style={{ border: '1px solid #e6e6e6' }} />
          <Accordion fluid styled id="link-detail-mobile">
            <Accordion.Title
              className="color-white standard-menu-font-size pdtnull pdlnull pdrnull pdbnull"
              active={settingAccordion === 0}
              index={0}
              onClick={handleClick}
            >
              {APP.LANGUAGE.ShareLinkSharedText.SubHeader}
              {settingAccordion === 0 ? (
                <Icon name="angle up" className="arrow-rotate-up fr text-size-l" />
              ) : (
                <Icon name="angle down" className="arrow-rotate-down fr text-size-l" />
              )}
            </Accordion.Title>
            <Accordion.Content
              className="pdtnull pdlnull pdrnull"
              active={settingAccordion === 0}
              content={
                <ReactQuillContent
                  modules={ReactQuillModules}
                  message={translateToQuill(props.waURLTextData.message)}
                />
              }
            />
          </Accordion>
          {!props.waURLTextData.isEditAllowed &&
          props.isWAEntryPointAdditionalMsgAllowed &&
          props.waURLTextData.additionalMessage &&
          props.waURLTextData.additionalMessage.trim() != '' ? (
            <React.Fragment>
              <div className="title-sms bold mrtm">{APP.LANGUAGE.ShareURL.AdditonalMessage}</div>
              <div className="title-sms wrap-link mrts">{props.waURLTextData.additionalMessage}</div>
            </React.Fragment>
          ) : (
            ''
          )}
          {props.waURLTextData.isEditAllowed && props.isWAEntryPointAdditionalMsgAllowed ? (
            <React.Fragment>
              <div className="additional-message-wrapper mrtm">
                <div className="title-sms mrts mrbxs bold">{APP.LANGUAGE.ShareURL.AdditonalMessage}</div>
                <MobileTextAreaContent
                  message={props.additionalTextMessage}
                  onChange={props.setAdditionalTextMessage}
                  characterLimit={props.textMessageCharacterLimit}
                  errorMsg={props.textMessageValidState.errorMessage}
                  backdropId="backdrop-1"
                  tabIndex="2"
                />
              </div>
            </React.Fragment>
          ) : (
            ''
          )}
          {!props.waURLTextData.isEditAllowed &&
          props.isWAEntryPointAdditionalMsgAllowed &&
          props.waURLTextData.additionalMessage &&
          props.waURLTextData.additionalMessage.trim() != '' ? (
            <React.Fragment>
              <hr style={{ border: '1px solid #e6e6e6' }} />
              <div className="color-neutral-center-gray">{APP.LANGUAGE.ShareURL.EditNotAllow}</div>
            </React.Fragment>
          ) : (
            ''
          )}
        </Container>
        <Container fluid as={Media} greaterThanOrEqual="tablet" className="modal-session-border">
          <div className="modal-session-bg no-corner">
            <div className="title-sms bold">{APP.LANGUAGE.ShareLinkSharedText.SubHeader}</div>
            <ReactQuillContent modules={ReactQuillModules} message={translateToQuill(props.waURLTextData.message)} />
            {!props.waURLTextData.isEditAllowed &&
            props.isWAEntryPointAdditionalMsgAllowed &&
            props.waURLTextData.additionalMessage &&
            props.waURLTextData.additionalMessage.trim() != '' ? (
              <React.Fragment>
                <div className="title-sms bold mrtm">{APP.LANGUAGE.ShareURL.AdditonalMessage}</div>
                <div className="wrap-link title-sms mrts">{props.waURLTextData.additionalMessage}</div>
              </React.Fragment>
            ) : (
              ''
            )}
          </div>
          {props.waURLTextData.isEditAllowed && props.isWAEntryPointAdditionalMsgAllowed ? (
            <div className="additional-message-wrapper mrtm">
              <div className="title-sms mrts mrbxs bold">{APP.LANGUAGE.ShareURL.AdditonalMessage}</div>
              <MobileTextAreaContent
                message={props.additionalTextMessage}
                onChange={props.setAdditionalTextMessage}
                characterLimit={props.textMessageCharacterLimit}
                errorMsg={props.textMessageValidState.errorMessage}
                backdropId="backdrop-1"
                tabIndex="2"
              />
            </div>
          ) : (
            ''
          )}
        </Container>
        {!props.waURLTextData.isEditAllowed &&
        props.isWAEntryPointAdditionalMsgAllowed &&
        props.waURLTextData.additionalMessage &&
        props.waURLTextData.additionalMessage.trim() != '' ? (
          <React.Fragment>
            <Container fluid as={Media} at="tablet">
              <hr style={{ border: '1px solid #e6e6e6' }} />
            </Container>
            <Container fluid as={Media} at="tablet" className="color-neutral-center-gray mrts">
              {APP.LANGUAGE.ShareURL.EditNotAllow}
            </Container>
            <Container as={Media} greaterThanOrEqual="computer" className="helper-color text-size-mms">
              {APP.LANGUAGE.ShareURL.EditNotAllow}
            </Container>
          </React.Fragment>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default CenterPanel;

const ReactQuillModules = {
  toolbar: false, // Hide the toolbar
};
